import { Box, Stack, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faImage } from "@fortawesome/pro-light-svg-icons"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    photo: {
        width: "100%",
        height: "6rem",
        objectFit: "cover",
    },
    placeholder: {
        width: "100%",
        height: "6rem",
        background: theme.palette.tailwind.slate[200],
        color: theme.palette.tailwind.slate[400],
    },
    icon: {
        fontSize: ".875rem",
    },
    caption: {
        fontSize: ".625rem",
        fontWeight: 600,
    },
}))

type Props = Readonly<{
    photoUrl?: string
}>

export function DishCardPhoto({ photoUrl }: Props) {
    const { classes } = useStyles()

    if (photoUrl) return <Box component="img" src={photoUrl} className={classes.photo} />

    return (
        <Stack className={classes.placeholder} alignItems="center" justifyContent="center" spacing=".25rem">
            <FontAwesomeIcon icon={faImage} className={classes.icon} />
            <LocalizedStrict id="merchant-menu-templates-dish-no-photo">
                <Typography variant="caption" className={classes.caption}>
                    No template photo
                </Typography>
            </LocalizedStrict>
        </Stack>
    )
}
